import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseModalDirective } from '@app/components/modals/base-modal';
import { isRenewBenefits, isReportChanges, isPresumptiveApp } from '@app/helpers/mode.helpers';
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    templateUrl: './save-exit.component.html',
    styleUrls: ['./save-exit.component.scss'],
    standalone: false
})
export class SaveExitModalComponent extends BaseModalDirective implements OnInit {
  @Input()sectionId : any;
  @Input()appType : any;
  isPresumptive = false;
  isRenewBenefitsAppType = false;
  isReportChangesAppType = false;
  appKeyWord;
  isRenewal:boolean = false;
  mobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  isPreterm = sessionStorage.getItem('isPreterm') === "PRETERM" && (sessionStorage.getItem('appType') === 'RB' || (sessionStorage.getItem('appType') === 'REDETERMINATION'  && sessionStorage.getItem('isKepro') === "true"));
  isEbmsDriverFlow = JSON.parse(sessionStorage.getItem("embsDriverFlow"))
  submitWarningPopup= false;
  selectionMade = false;

  constructor(
    protected modalRef: BsModalRef, 
    protected builder: FormBuilder,
     public analytics: GoogleAnalyticsService
    ){
    super(modalRef, builder);
  }
  
  ngOnInit() {
    this.isRenewBenefitsAppType = isRenewBenefits(this.appType);
    this.isReportChangesAppType = isReportChanges(this.appType)
    this.appKeyWord = this.isReportChangesAppType ? 'CHANGE' : this.isRenewBenefitsAppType ? 'RENEWAL' : this.mobileUser ? 'APPLICATION_TEXT' : 'APPLICATION';
	  this.isRenewal = this.appKeyWord === 'RENEWAL' ? true : false;
	  this.isPresumptive = isPresumptiveApp(this.appType);
  }

  showSubmitTab() {
    const sectionToHide = ['HHAPL', 'RMBSL'];
    if (sectionToHide.find((item) => item === this.sectionId)) {
      return false;
    } else {
      return true;
    }
  }

  select (value) {
      this.appType = value;
      this.selectionMade = true;
  }

  next () {
    if (this.isEbmsDriverFlow && this.appType === 'submit') {
        this.submitWarningPopup = true;
        this.analytics.trackEbmsWrngPopup();
    } else {
      this.onConfirm();
    }
  }

  onConfirm(): void {
    this.isEbmsDriverFlow ? this.analytics.trackSaveAndExitButton('ebms_' + this.appType) :  this.analytics.trackSaveAndExitButton(this.appType);
    this.hide({appType: this.appType});
  }
 
  onCancel(): void {
    this.hide('');
  }

}
